import { styled } from 'parkdepot-shared/theme'

export const CardsContainer = styled('div', ({}) => ({
    margin: '0.8rem 0 2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
}))

export const CardTitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.LabelSmall,
    fontWeight: 700,
    margin: 0
}))

export const Card = styled<'div', { $colored?: boolean; $isLast?: boolean }>(
    'div',
    ({ $theme, $colored = false, $isLast = true }) => ({
        backgroundColor: $colored ? $theme.colors.primary : '#fff',
        borderRadius: '1.4rem',
        padding: '4.3rem 2rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: $isLast ? '0px' : '2rem',
        cursor: 'pointer',
        ...(!$colored && {
            // border: '1px dashed #B3BBC7'
            backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='gray' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");border-radius: 14px;`
        })
    })
)

export const CardIcon = styled<'i', { $white?: boolean }>('i', ({ $white }) => ({
    fontSize: '2.4rem',
    color: $white ? '#fff' : '#000'
}))

export const CardText = styled<'p', { $white?: boolean }>('p', ({ $theme, $white }) => ({
    ...$theme.typography.ParagraphSmall,
    color: $white ? '#fff' : '#000',
    textAlign: 'center',
    margin: '4px 0 0',
    fontWeight: 400
}))

export const CardTitleContainer = styled('div', ({}) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 0 0.8rem',
    alignItems: 'center'
}))
